import axios from 'axios'

const isLocal = ~location.href.indexOf('localhost')

export default axios.create({
    baseURL: isLocal ? 'http://78.46.31.130:8001/api/' : '/api/',
    timeout: 30000,
});
